<template>
  <div class="container">
    <h1>MOUNTAIN & MAIDEN</h1>
    <p class="lead">Documentary | 2020 | 19' | Color | English SUB</p>

    <carousel per-page="1" navigation-enabled="true" autoplay="true" autoplay-timeout="7000">
      <slide>
        <img
            src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/Mountain%26Maideklein.jpg?alt=media&token=0eece105-21fe-46c0-8489-18db0b6251ee"
            class="d-block w-100">
      </slide>
    </carousel>


    <!--        <img src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/52.jpg?alt=media&token=1e0941ff-0beb-4486-9230-8d42e45fca92" class="img-fluid" alt="Responsive image">-->
    <p class="lead mt-4">This is the story of a day in the life of Aspiya. A 10-year-old girl living with her
      younger brother, older sister and parents in a one-room-shack in New Delhi near Asia’s biggest landfill.</p>
<!--    <div class='embed-container'>-->
<!--      <iframe class="" src="https://player.vimeo.com/video/425279550" width="1066" height="600" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>-->
<!--    </div>-->

    <p class="lead mt-3 mb-4">
      <span class="font-weight-normal">DIRECTOR |</span> Anton von Heiseler, Shmuel Hoffman <br>
      <span class="font-weight-normal">CINEMATOGRAPHER |</span> Anton von Heiseler, Shmuel Hoffman <br>
      <span class="font-weight-normal">PRODUCER |</span> Margelit Hoffman, Narayan Tushar, Sheikh Ayub <br>
    </p>

    <a class="btn btn-secondary" href="https://www.waterbear.com/watch/mini-doc/616e9912c3a0557a7ee508da"> Watch Here</a>
  </div>
</template>

<script>
export default {
  name: "mountainandmaiden"
}
</script>

<style scoped>

</style>
